import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

function ServiceIcon({name}) {
  return <SafeIcon icon={FiIcons[name] || FiIcons.FiCheckCircle} />;
}

export default ServiceIcon;
